export default __webpack_public_path__ + "static/media/gallery_04.b8d675ed.jpg";